import { render } from "./thumbsticks.vue?vue&type=template&id=2eee09b4&scoped=true"
import script from "./thumbsticks.vue?vue&type=script&lang=js"
export * from "./thumbsticks.vue?vue&type=script&lang=js"

import "./thumbsticks.vue?vue&type=style&index=0&id=2eee09b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eee09b4"]])

export default __exports__